<template>
    <div class="mt-30">
        <div class="row">
            <div class="col-md-6" >
                <h3 class="page-header m-0">
                <i class="fa fa fa-rupee animated bounceInDown show-info"></i> Lottery Record</h3>
            </div>
        </div>
        <div class="col-md-12 pt-10">
            <div class="">
                <table class="table ">
                    <thead>
                        <th>S.No.</th>
                        <th>VS-DIGI</th>
                        <th>Name</th>
                        <th>Rewards</th>
                        <th>Position</th>
                        <th>Created</th>
                        <th>Action</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in lotteries" :key="item.id">
                            <td>{{ index+1 }}</td>
                            <td>{{ item.generatedid ?? 'N/A' }}</td>
                            <td>{{ item.customername ?? 'N/A' }}</td>
                            <td>{{ item.rewards ?? 'N/A' }}</td>
                            <td>{{ item.position ?? 'N/A' }}</td>
                            <td>{{ moment(item.created_at).format('YYYY-MM-DD hh:mm:ss A') }}</td>
                            <td>
                                <span
                                    v-if="item.rolledback == 1"
                                    class="badge btn-danger"
                                    style="cursor: default;"
                                >
                                    Rolled Back
                                </span>
                                <button
                                    v-else
                                    type="button"
                                    class="btn btn-danger btn-sm"
                                    @click="rollbackRecord(item)"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            lotteries: [],
            moment: moment,
        }
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapGetters([  ]),
    },
    methods: {
        refresh(){
            let param = {fromdate: this.fromdate, todate: this.todate}
            axios.post('api/lottery/record/fetch',param)
                .then((response)=>{ 
                    this.lotteries = response.data.records;
                 })
                .catch((error) => console.log(error));
        },
        rollbackRecord(item) {
            if (!confirm('Are you sure you want to delete this lottery record?')) {
                return;
            }

            this.$store.commit('assignloadingstatus', 1);
            axios.post('api/lottery/record/rollback', { id: item.id })
                .then((response) => {
                    this.$notify({
                        text: response.data.message || 'Lottery record rolled back successfully.',
                        type: 'success',
                    });
                    this.refresh();
                })
                .catch((error) => {
                    const message = error.response?.data?.message || 'Something went wrong.';
                    this.$notify({
                        text: message,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.$store.commit('assignloadingstatus', 0);
                });
        }
    }
}
</script>
